module.exports = __webpack_public_path__ + "assets/img/home-typical-scenarios.feef34b9.png";